module.exports = __webpack_public_path__ + "media/page-6.bef3987a.mp3";